import { render, staticRenderFns } from "./OffersOrPlansContainer.vue?vue&type=template&id=06069daa&scoped=true&"
import script from "./OffersOrPlansContainer.vue?vue&type=script&lang=js&"
export * from "./OffersOrPlansContainer.vue?vue&type=script&lang=js&"
import style0 from "./OffersOrPlansContainer.vue?vue&type=style&index=0&id=06069daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06069daa",
  null
  
)

export default component.exports